import { getFormData } from '../../../helpers';

/**
 * Gets updated OwnHome value
 * @returns {String} The processed OwnHome value
 */
export function getOwnHomeValue() {
	const formData = getFormData(),
		ownHomeElement = document.querySelector('[name="OwnHome"]');

	if (ownHomeElement && ownHomeElement.type === 'checkbox') {
		return ownHomeElement.checked ? 'Yes' : 'No';
	} else {
		return formData.OwnHome === 'Authorized' ? 'Yes' : formData.OwnHome;
	}
}